/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable */
import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import withStyles from '@material-ui/core/styles/withStyles';
import { object } from 'prop-types';

const useStyles = (theme) => ({
    notFoundStyles: { position: 'relative' },
    NotFound: { maxWidth: '100%' },
    h1Styles: { fontSize: '4.0625rem', marginBottom: '-30px' },
    mobileH1Styles: { fontSize: '2.5rem', marginBottom: '-30px' },
    wrapperStyles: {
        position: 'absolute', top: '50px', left: '50%', WebkitTransform: 'translateX(-50%)', transform: 'translateX(-50%)', width: '100%',
    },
    mobileWrapperStyles: {
        position: 'absolute', left: '50%', WebkitTransform: 'translateX(-50%)', transform: 'translateX(-50%)', width: '100%', top: '35px',
    },
    btnSend: {
        color: theme.palette.common.black,
        width: '100%',
        padding: '10px 50px',
        textAlign: 'center',
        backgroundColor: theme.palette?.primary?.main,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.palette?.primary?.main,
            cursor: 'pointer',
        },
        fontWeight: '700',
        fontSize: '1rem',
        textDecoration: 'none !important',
        fontFamily: theme?.typography?.fontFamily,
    },
    content: {
        marginBottom: '40px',
    },
});
const PageNotFound = (props) => {
    const { classes, isFromOffline, image_url } = props;
    const isMobile = !useMediaQuery('(min-width:600px)');
    const modileUrl = 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/bltdf278b97c811496d/63f35387acda661aad7de43b/not-found-mobile.jpg';
    return (
        <>
            <div className={classes.notFoundStyles}>
                <img alt="Not-Found" className={classes.NotFound} src={isMobile ? `${modileUrl}` : `${image_url}`} />
                <div className={isMobile ? classes.mobileWrapperStyles : classes.wrapperStyles}>
                    <Container className="pt-sm-0 mt-sm-0 pt-lg-4 mt-lg-4 pt-md-3 pt-md-3 pt-xl-5 mt-xl-5">
                        <h1 className={isMobile ? classes.mobileH1Styles : classes.h1Styles}>OOPS!</h1>
                        <div className={classes.content}>
                            <p>{isFromOffline ? `${isMobile ? 'Looks like you don’t have an internet ' : 'Looks like you don’t have an internet connection right now.'}` : 'The page you requested does not exist.'}</p>
                            {isMobile && isFromOffline && <p className="pb-0 mb-0">connection right now.</p>}
                            {isFromOffline ? <p className="pb-sm-4 mb-sm-2">Please check your connection and try again.</p> : null}
                        </div>
                        <Link prefetch={false} to={isFromOffline ? '/' : '/c/all-plants'} className={`${classes.btnSend} pl-4 pr-4 pr-md-5 pl-md-5`}>
                            <span aria-label={isFromOffline ? 'RETRY' : 'SHOP ALL PLANTS'}> {isFromOffline ? 'RETRY' : 'SHOP ALL PLANTS'}</span>
                        </Link>
                    </Container>
                </div>
            </div>
        </>
    );
};
PageNotFound.defaultProps = {
    isFromOffline: false,
};
PageNotFound.propTypes = {
    classes: object.isRequired
};
export default withStyles(useStyles)(PageNotFound);
